/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Role } from './role';


/**
 * Mapped roles
 */
export interface RoleMapping { 
    id?: number;
    /**
     * the nickname of the role(s)
     */
    roleNickname?: string;
    roles?: Array<Role>;
}

